import config from 'config';
import { createSelector } from 'reselect';
import checkIsMobile, { isInStandaloneMode } from 'shared/utils/checkMobileDevice';


const getAutorizationData = state => {
  const { userInfo, loginForm, otpForm } = state.auth;
  return {
    userInfo,
    loginForm,
    otpForm,
  };
};

export default createSelector(
  getAutorizationData,
  ({ userInfo, loginForm, otpForm }) => {
    if (otpForm.currentLocation && otpForm.currentLocation.includes('appointments')) {
      return true;
    }

    return !!(
      userInfo.phoneNumber
      && userInfo.verificationToken
      && loginForm.submitted
      && (otpForm.previousLocation.includes('login')
        || otpForm.previousLocation.includes('otp-verification')
        || Number(config.org_id)
        || checkIsMobile())
    );
  },
);
